import type { Claims } from "@allergy123/auth-client";

/** Synthetic sign-in personas for local development; they match services/api/src/lib/fixtures.ts. */
export const personas: Record<"learner" | "manager" | "solo" | "other", Claims> = {
  learner: { sub: "mock-user", email: "learner@example.test", name: "Mock Learner", groups: ["learn"] },
  manager: { sub: "mock-practice-admin", email: "manager@example.test", name: "Mock Manager", groups: ["learn"] },
  solo: { sub: "mock-solo", email: "solo@example.test", name: "Solo Learner", groups: ["learn"] },
  other: { sub: "mock-other", email: "other@example.test", name: "Other Practice", groups: ["learn"] },
};
export type PersonaKey = keyof typeof personas;

const KEY = "a123.mock.persona";

export function currentPersonaKey(): PersonaKey {
  try {
    const k = localStorage.getItem(KEY) as PersonaKey | null;
    return k && k in personas ? k : "learner";
  } catch {
    return "learner";
  }
}

export function mockPersona() {
  return personas[currentPersonaKey()];
}

export function setPersona(key: PersonaKey) {
  try {
    localStorage.setItem(KEY, key);
    sessionStorage.clear();
  } catch {
    /* ignore */
  }
  window.location.assign("/");
}
